import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Form, Grid, Button } from 'semantic-ui-react';
import { Field } from 'redux-form';
import ReactTable from 'react-table';
import { get, debounce } from 'lodash';

import { SelectField } from 'Common/SemanticWrapper';
import { hasAccess } from 'Common/Security/SecurityHelpers';
import { ViewApplicationDistributionFieldEnum } from 'Common/FieldEnum';
import { VIEW_APPLICATION_DISTRIBUTION_FORM_NAME } from 'Common/FormEnum';
import { AccessInfoEnum } from 'Common/Constants/Enumeration/AccessInfoEnum';
import {
  ReactTableWrapperColumnProperties,
  ReactTableWrapperCogColumnProperties,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { PopupTextCell } from 'Common/GridHelper';

class ApplicationGridForm extends Component {
  state = {
    pageNumber: 1,
    pageSize: 20,
    sorted: [],
    filtered: [],
  };

  onHistoryClick = application => {
    this.props.history.push(
      `/manageapplication/history/${application.FamilyId}`
    );
  };

  menuOptions = hasAccess(
    AccessInfoEnum.ManageApplication.Id,
    AccessInfoEnum.ManageApplication.ProductId,
    this.props.accessInfo
  )
    ? [
        {
          icon: 'history',
          text: 'History',
          handler: this.onHistoryClick,
          disabledWhen: () => this.props.isReadOnly
        },
      ]
    : [];

  columns = [
    {
      id: ViewApplicationDistributionFieldEnum.FamilyId,
      Header: 'Family #',
      accessor: ViewApplicationDistributionFieldEnum.FamilyId,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.FamilyId];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.HouseholdName,
      Header: 'Household Name',
      accessor: ViewApplicationDistributionFieldEnum.HouseholdName,
      Cell: ({ original }) => {
        const value =
          original[ViewApplicationDistributionFieldEnum.HouseholdName];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.HouseholdSSN,
      Header: 'Household SSN',
      accessor: ViewApplicationDistributionFieldEnum.HouseholdSSN,
      Cell: ({ original }) => {
        const value =
          original[ViewApplicationDistributionFieldEnum.HouseholdSSN];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.Address1,
      Header: 'Address 1',
      accessor: ViewApplicationDistributionFieldEnum.Address1,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.Address1];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.Address2,
      Header: 'Address 2',
      accessor: ViewApplicationDistributionFieldEnum.Address2,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.Address2];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.City,
      Header: 'City',
      accessor: ViewApplicationDistributionFieldEnum.City,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.City];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.State,
      Header: 'State',
      accessor: ViewApplicationDistributionFieldEnum.State,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.State];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.ZipCode,
      Header: 'Zip Code',
      accessor: ViewApplicationDistributionFieldEnum.ZipCode,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.ZipCode];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.HomePhone,
      Header: 'Home Phone',
      accessor: ViewApplicationDistributionFieldEnum.HomePhone,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.HomePhone];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.WorkPhone,
      Header: 'Work Phone',
      accessor: ViewApplicationDistributionFieldEnum.WorkPhone,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.WorkPhone];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: ViewApplicationDistributionFieldEnum.ApplicationType,
      Header: 'Application Type',
      accessor: ViewApplicationDistributionFieldEnum.ApplicationType,
      Cell: ({ original }) => {
        const value = original[ViewApplicationDistributionFieldEnum.ApplicationType];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },    
    {
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.menuOptions,
        });
      },
      ...ReactTableWrapperCogColumnProperties,
    },
  ];

  componentDidUpdate(prevProps) {
    const prevTypeId =
      prevProps.formValues[ViewApplicationDistributionFieldEnum.TypeId];
    const currentTypeId = this.props.formValues[
      ViewApplicationDistributionFieldEnum.TypeId
    ];
    if (prevTypeId !== currentTypeId) {
      this.fetchData();
    }
  }

  fetchData = async () => {
    const { getResults, formValues } = this.props;
    const { pageNumber, pageSize, sorted, filtered } = this.state;
    const typeId = formValues[ViewApplicationDistributionFieldEnum.TypeId];
    if (typeId === null) return;

    let filters = [];
    let sorts = [];

    filters = filtered.reduce((acc, filterValue) => {
      acc.push({
        FilterName: filterValue.id,
        FilterValue: filterValue.value,
      });
      return acc;
    }, []);

    sorts = sorted.reduce((acc, sortValue) => {
      acc.push({
        SortName: sortValue.id,
        SortDirection: sortValue.desc ? 'desc' : 'asc',
      });
      return acc;
    }, []);

    const data = {
      TypeId: typeId,
      PagingDetails: {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Filter: filters,
        SortColumn: sorts,
      },
    };
    await getResults(data);
  };
  fetchDataDebounced = debounce(this.fetchData, 350);

  handlePageChange = page => {
    this.setState({ pageNumber: page + 1 }, this.fetchData);
  };

  handlePageSizeChange = pageSize => {
    this.setState({ pageSize }, this.fetchData);
  };

  handleSortedChange = sorted => {
    this.setState({ sorted }, this.fetchData);
  };

  handleFilteredChange = filtered => {
    this.setState({ filtered }, this.fetchDataDebounced);
  };

  handleClearFilter = () => {
    this.setState({ filtered: [], sorted: [] }, this.fetchData);
  };

  render() {
    const { loadingResults, typeOptions, results } = this.props;
    const { sorted, filtered } = this.state;
    const data = get(results, 'Result', []);

    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                name={ViewApplicationDistributionFieldEnum.TypeId}
                component={SelectField}
                label={'Application Type'}
                options={typeOptions}
              ></Field>
            </Grid.Column>
            <Grid.Column width={10} textAlign={'right'} verticalAlign="bottom">
              <Button onClick={this.handleClearFilter}>Clear Filters</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <ReactTable
          manual
          loading={loadingResults}
          data={data}
          columns={this.columns}
          onPageChange={this.handlePageChange}
          onPageSizeChange={this.handlePageSizeChange}
          multiSort={false}
          minRows={data.length === 0 ? 20 : data.length}
          onSortedChange={this.handleSortedChange}
          onFilteredChange={this.handleFilteredChange}
          sorted={sorted}
          filtered={filtered}
          pages={results.TotalPages}
        />
      </Form>
    );
  }
}

ApplicationGridForm = reduxForm({
  form: VIEW_APPLICATION_DISTRIBUTION_FORM_NAME,
})(ApplicationGridForm);

export { ApplicationGridForm };



// WEBPACK FOOTER //
// ./src/pages/viewapplicationdistribution/components/ApplicationGridForm.js